// extracted by mini-css-extract-plugin
export default {"SocialUl":"SocialSection_SocialUl__JDMB9","List":"SocialSection_List__d0Yca","Link":"SocialSection_Link__pqROg","Image":"SocialSection_Image__teFl5"};